import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class PingStatusMixin extends Vue {
  private pingAgeMinutes(lastPing: string): number {
    if (!lastPing) return Infinity;
    return (Date.now() - new Date(lastPing).getTime()) / 60000;
  }

  protected pingColor(lastPing: string): string {
    const age = this.pingAgeMinutes(lastPing);
    if (age < 30) return 'green lighten-4';
    if (age < 60) return 'orange lighten-4';
    return 'red lighten-4';
  }

  protected pingTimeAgo(lastPing: string): string {
    if (!lastPing) return '-';
    const minutes = this.pingAgeMinutes(lastPing);
    if (minutes < 1) return Math.floor(minutes * 60) + 's';
    if (minutes < 60) return Math.floor(minutes) + 'm';
    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);
    if (h < 24) return m > 0 ? h + 'h ' + m + 'm' : h + 'h';
    return Math.floor(h / 24) + 'd';
  }
}
